import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminDropdown.css';

function AdminDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleMenuClick = (path) => {
    setIsOpen(false);
    navigate(path);
  };

  return (
    <div className="admin-dropdown" ref={dropdownRef}>
      <button
        className="admin-dropdown-toggle"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Admin menu"
      >
        Admin
        <span className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>▼</span>
      </button>

      {isOpen && (
        <div className="admin-dropdown-menu">
          <button
            className="admin-dropdown-item"
            onClick={() => handleMenuClick('/admin/users')}
          >
            Manage Users
          </button>
          <button
            className="admin-dropdown-item"
            onClick={() => handleMenuClick('/admin/seasons')}
          >
            Manage Seasons
          </button>
          <button
            className="admin-dropdown-item"
            onClick={() => handleMenuClick('/admin/audit')}
          >
            Audit Log
          </button>
          <button
            className="admin-dropdown-item"
            onClick={() => handleMenuClick('/admin/security-events')}
          >
            Security Events
          </button>
          {/* Future menu items can be added here */}
          {/*
          <button
            className="admin-dropdown-item"
            onClick={() => handleMenuClick('/admin/teams')}
          >
            Manage Teams
          </button>
          <button
            className="admin-dropdown-item"
            onClick={() => handleMenuClick('/admin/venues')}
          >
            Manage Venues
          </button>
          */}
        </div>
      )}
    </div>
  );
}

export default AdminDropdown;
